import { JsonObject } from '@se/cp.common';
import { isNotNullOrUndefined } from '@se/cp.engine';
import { CheckedDataService, DataBinding } from '@se/se.platform.base';
import { ExportVasselReportParams } from './interfaces';

const DEFAULT_SEPARATOR = ' ';
const ROOT_DATABINDING = 'Report.CardioRMReport';
const PARENT_BINDING = `${ROOT_DATABINDING}.JSonData.CardioCT.CoronaroTC`;
const INPUT_DATABINDING = `ClinicalEvaluation.ClinicalEvaluationCombo`;
//const OUTPUT_DATABINDING = '{X}Report';
const CT_SITE_LIST = 'lsCTSite';
const CT_CLINICAL_EVALUATION_COMBO_LIST = 'lsCTClinicalEvaluationCombo';

export class ExportVasselReport {
    constructor(
        private dataService: CheckedDataService,
        private dataSourceService: CheckedDataService,
    ) {}

    private verifyDataset = (): boolean => {
        const datasetRoot = this.dataService.getValue?.(new DataBinding(ROOT_DATABINDING));
        if (!datasetRoot) {
            console.error('constraint Error: ExportVasselReport - DATASET ERRATO');
            return false;
        }
        return true;
    };

    export([coronaryVassel, valueSeparator]: ExportVasselReportParams) {
        //const outputDatabinding = parseDatabinding(`${PARENT_BINDING}.${OUTPUT_DATABINDING}`, coronaryVassel);
        const inputDatabinding = `${PARENT_BINDING}.${INPUT_DATABINDING}`;
        if (!this.verifyDataset()) return null;

        const sites = this.dataSourceService.getEntities(new DataBinding(CT_SITE_LIST)) ?? [];
        const siteId = sites
            .find((item) => item.getPropertyPrimitiveValue('ShortLabel') === coronaryVassel)
            ?.getPropertyPrimitiveValue('Id');
        const combos = this.dataSourceService.getEntities(new DataBinding(CT_CLINICAL_EVALUATION_COMBO_LIST)) ?? [];
        const filteredCombos = combos.filter((item) => item.getPropertyPrimitiveValue('IdCTSite') === siteId);
        filteredCombos.sort(
            (itemA, itemB) =>
                parseInt(itemA.getPropertyPrimitiveValue('Order') as string) -
                parseInt(itemB.getPropertyPrimitiveValue('Order') as string),
        );
        const filteredComboIds = filteredCombos.map((item) => item.getPropertyPrimitiveValue('Id'));
        const valuatedCombos = this.dataService.getEntities(new DataBinding(inputDatabinding)) ?? [];
        const valuesArray = filteredComboIds
            .map((comboId) => {
                const valueEntity = valuatedCombos
                    .find((entity) => {
                        const idCTClinicalEvaluation = entity.getPropertyPrimitiveValue(
                            'IdCTClinicalEvaluation',
                        ) as JsonObject;
                        return idCTClinicalEvaluation.Id === comboId;
                    })
                    ?.getPropertyPrimitiveValue('Value') as JsonObject | undefined;
                return valueEntity?.Report ?? valueEntity?.Description ?? null;
            })
            .filter(isNotNullOrUndefined);

        return valuesArray.join(valueSeparator ?? DEFAULT_SEPARATOR);
    }
}
